export function showMorePlans(){
    $('.pricing-plan .show-more button').on('click', function (){
        $(this).closest('.pricing-plan').toggleClass('opened');
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/showMorePlans.js